<template>
    <div class="fullBg animate__animated animate__bounceIn">
        <div class="rightBox">
            <div class="headP">
                <p class="img"><img
                    :src="userMsgData?userMsgData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{ userMsgData ? userMsgData.name : '' }}</span>
                    <span class="en">{{ userMsgData ? userMsgData.nameEn : '' }}</span>
                </p>
                <p class="position" v-if="$route.params.position">
                    <i><img :src="require('@/assets/img/playerImg/'+$route.params.position+'.svg')" alt=""></i>
                </p>
                <p class="playerMsg">
                    <i v-if="userMsgData.star?true:false">
                        <img :src="require('@/assets/img/playerImg/'+parseInt(userMsgData?userMsgData.star:0)+'.svg')"
                             alt="">
                        <em>{{ userMsgData.star }}</em>
                    </i>
                    <span class="star">
                        <img v-if="userMsgData&&userMsgData.star" v-for="i in 4"
                             :src="i<=Math.floor(userMsgData?userMsgData.star:0)?require('@/assets/img/updateImg/xingFull.svg'):(((userMsgData?userMsgData.star:0) >= (i-1) + '.5')?require('@/assets/img/updateImg/xingHalf.svg'):require('@/assets/img/updateImg/xingNo.svg'))"
                             alt="">
                        <img v-else src="../assets/img/updateImg/xing.svg" alt="">
                    </span>
                </p>
            </div>
            <div class="basicMsg">
                <p><span class="label">身高：</span><span
                    class="val PingFangMedium">{{ userMsgData && userMsgData.height ? userMsgData.height : '-' }}</span><span
                    class="unit">cm</span></p>
                <p><span class="label">体重：</span><span
                    class="val PingFangMedium">{{ userMsgData && userMsgData.weight ? userMsgData.weight : '-' }}</span><span
                    class="unit">kg</span></p>
                <p><span class="label">血型：</span><span
                    class="val PingFangMedium">{{ userMsgData && userMsgData.bloodType ? userMsgData.bloodType : '-' }}</span>
                </p>
                <p><span class="label">惯用手：</span><span
                    class="val PingFangMedium">{{ userMsgData && userMsgData.preferredHand ? userMsgData.preferredHand : '-' }}</span>
                </p>
                <p><span class="label">过敏史：</span><span
                    class="val PingFangMedium">{{ userMsgData && userMsgData.allergy ? userMsgData.allergy : '-' }}</span>
                </p>
            </div>
            <p class="tit">个人信息</p>
            <div class="professionalMsg">
                <ul class="header">
                    <li><span class="label">微信号码</span><span
                        class="value">{{ userMsgData && userMsgData.weixin ? userMsgData.weixin : '-' }}</span>
                    </li>
                    <li><span class="label">父亲姓名</span><span
                        class="value">{{ userMsgData && userMsgData.fatherName ? userMsgData.fatherName : '-' }}</span>
                    </li>
                    <li><span class="label">母亲姓名</span><span
                        class="value">{{ userMsgData && userMsgData.motherName ? userMsgData.motherName : '-' }}</span>
                    </li>
                    <li><span class="label">家庭住址</span><span
                        class="value">{{ userMsgData && userMsgData.address ? userMsgData.address : '-' }}</span>
                    </li>
                    <li><span class="label">身份证号</span><span
                        class="value">{{ userMsgData && userMsgData.identityCard ? userMsgData.identityCard : '-' }}</span>
                    </li>
                </ul>
                <ul>
                    <li><span class="label">电话号码</span><span
                        class="value">{{ userMsgData && userMsgData.phone ? userMsgData.phone : '-' }}</span>
                    </li>
                    <li><span class="label">父亲电话</span><span
                        class="value">{{ userMsgData && userMsgData.fatherPhone ? userMsgData.fatherPhone : '-' }}</span>
                    </li>
                    <li><span class="label">母亲电话</span><span
                        class="value">{{ userMsgData && userMsgData.motherPhone ? userMsgData.motherPhone : '-' }}</span>
                    </li>
                    <li><span class="label">邮   箱</span><span
                        class="value">{{ userMsgData && userMsgData.email ? userMsgData.email : '-' }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "playersDetail",
    data() {
        return {
            userMsgData: null,//球员基本信息
        }
    },
    mounted() {
        this.info();
    },
    methods: {
        info() {
            let data = {
                id: this.$route.params.id,
                // id: '5f09beaa2bbde45f19a054e7',
                info: 'personal'
            }
            this.playerMsg(data)
        },
        playerMsg(data) {
            this.$server.getUserMsg(data)
                .then((res) => {
                    this.userMsgData = res.data;
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + res.data.name + '的详细信息'), true, false)

                })
        }
    }
}
</script>

<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /*background-clip: content-box;*/
}

.rightBox {
    width: 75%;
    float: left;
    height: calc(100% - 8vw);
    box-sizing: border-box;
    display: inline-block;
    margin-bottom: 3vw;
    padding: 5vw 8vw 0 5vw;
    color: #fff;

    .tit {
        font-size: 36px;
        text-align: left;
        margin-bottom: 1.5vw;
        background-image: url("../assets/img/playerImg/titleBg.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        line-height: 4vw;
    }

    .headP {
        font-size: 44px;
        margin-top: 3vw;
        height: 8vw;
        /*line-height: 8vw;*/
        background-size: auto 100%;
        background-repeat: no-repeat;
        position: relative;

        .img {
            float: left;
            width: 7vw;
            height: 7vw;
            overflow: hidden;
            border-radius: 50%;
            background-color: rgba(12, 12, 13, 1);

            img {
                width: 100%;
            }
        }

        .name {
            padding-left: 3vw;
            float: left;
            font-family: PingFangMedium;

            span {
                display: block;
            }

            span.zh {
                font-weight: bolder;
                font-size: 60px;
                background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            span.en {
                font-size: 30px;
                background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .position {
            float: left;
            margin-left: 2vw;
            margin-top: 1.5vw;
        }

        .playerMsg {
            position: absolute;
            right: -6.9vw;
            top: 3vw;
            margin-left: 2vw;
            text-align: left;
            margin-top: 1.5vw;

            i, span {
                /*display: block;*/
                /*line-height: 2.5vw;*/
            }

            i {
                float: left;
                margin-top: .3vw;
                margin-right: .3vw;
                position: relative;
                width: 3vw;
                display: flex;

                img {
                    position: absolute;
                    left: 0;
                    z-index: -10;
                }

                em {
                    font-family: akrobatBold;
                    margin-left: .4vw;
                    text-align: center;
                    font-style: normal;
                    font-size: 38px;
                    width: 100%;
                }
            }

            .star {
                background-image: url("../assets/img/playerImg/bg1.svg");
                background-size: 100% 100%;
                padding-right: 5vw;
                padding-left: 1vw;

                img {
                    width: 1.5vw;
                    height: 1.5vw;
                    margin-right: 1vw;
                }
            }
        }
    }

    .basicMsg {
        font-size: 22px;
        margin-top: 2.5vw;
        padding-bottom: 1vw;
        text-align: left;
        width: 110%;

        p {
            height: 2.5vw;
            line-height: 2.5vw;
            display: inline-block;
            width: calc(33.3% - 4vw);
            background-image: url("../assets/img/updateImg/personalLittle.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: left;
            padding-left: 2vw;
            box-sizing: border-box;
            margin-bottom: 1vw;
            margin-right: 4vw;

            .unit {
                color: rgba(255, 255, 255, .6);
                font-size: 30px;
                font-family: PingFang;
                margin-left: .5vw;
            }

            span {
                float: left;
            }

            &:first-child, &:nth-child(2), &:nth-child(3) {
                font-size: 34px;
            }

            .label {
                font-size: 24px;
                color: rgba(255, 255, 255, .6);
                padding-right: .5vw;
            }

            .val {
                padding-left: 2vw;
            }
        }
    }

    .professionalMsg {
        text-align: left;

        ul {
            width: 50%;
            float: left;
            font-size: 26px;
            font-family: PingFangMedium;
            font-weight: normal;

            li {
                line-height: 3vw;
                padding-right: 2vw;
                box-sizing: border-box;
            }

            .label {
                display: inline-block;
                width: 23%;
                padding-right: 1vw;
                box-sizing: border-box;
                color: rgba(234, 240, 247, .6);
            }

            .value {
                color: rgba(255, 255, 255, .8);
            }
        }
    }
}
</style>
